import React from 'react';
import FeatureGameDialog from '../../features/games/details/components/GameDialog';

const GameDialog: React.FC<React.ComponentProps<typeof FeatureGameDialog>> = (props) => <FeatureGameDialog {...props} />;

export default GameDialog;
